/**
 * PlaylistStatusBadge Component
 * Displays the status of a playlist with appropriate styling
 */

type PlaylistStatus = 'pending' | 'processing' | 'completed' | 'failed';

interface Props {
  status: PlaylistStatus;
  errorMessage?: string | null;
}

export default function PlaylistStatusBadge({ status, errorMessage }: Props) {
  const getStatusClass = () => {
    switch (status) {
      case 'pending':
        return 'status-badge status-pending';
      case 'processing':
        return 'status-badge status-processing';
      case 'completed':
        return 'status-badge status-completed';
      case 'failed':
        return 'status-badge status-failed';
      default:
        return 'status-badge';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'pending':
        return 'Pending';
      case 'processing':
        return 'Processing...';
      case 'completed':
        return 'Completed';
      case 'failed':
        return 'Failed';
      default:
        return status;
    }
  };

  return (
    <span className={getStatusClass()} title={errorMessage || undefined}>
      {status === 'processing' && <span className="spinner" />}
      {getStatusText()}
    </span>
  );
}
